/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R404RouteImport } from './routes/404'
import { Route as R403RouteImport } from './routes/403'
import { Route as SettingsRouteRouteImport } from './routes/_settings/route'
import { Route as BaseRouteRouteImport } from './routes/_base/route'
import { Route as BaseIndexRouteImport } from './routes/_base/index'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgetPasswordRouteImport } from './routes/auth/forget-password'
import { Route as ApiMonitorSentryRouteImport } from './routes/api/_monitor/sentry'
import { Route as ApiMonitorHealthcheckRouteImport } from './routes/api/_monitor/healthcheck'
import { Route as SettingsSettingsUsersRouteImport } from './routes/_settings/settings/users'
import { Route as SettingsSettingsRolesRouteImport } from './routes/_settings/settings/roles'
import { Route as SettingsSettingsQueryBuilderRouteImport } from './routes/_settings/settings/query-builder'
import { Route as SettingsSettingsGeneralRouteImport } from './routes/_settings/settings/general'
import { Route as SettingsSettingsDesignRouteImport } from './routes/_settings/settings/design'
import { Route as MonitorSentrySsrPageRouteImport } from './routes/_monitor/sentry/ssr-page'
import { Route as MonitorSentryCsrPageRouteImport } from './routes/_monitor/sentry/csr-page'
import { Route as MonitorPreviewErrorPageRouteImport } from './routes/_monitor/preview/error-page'
import { Route as BaseTableTableIdRouteRouteImport } from './routes/_base/table/$tableId/route'
import { Route as SettingsDeveloperToolQueryBuilderRouteImport } from './routes/_settings/developer/tool/query-builder'
import { Route as BaseTableTableIdViewIdRouteImport } from './routes/_base/table/$tableId/$viewId'

const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/_settings',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseRouteRoute = BaseRouteRouteImport.update({
  id: '/_base',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseIndexRoute = BaseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgetPasswordRoute = AuthForgetPasswordRouteImport.update({
  id: '/auth/forget-password',
  path: '/auth/forget-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiMonitorSentryRoute = ApiMonitorSentryRouteImport.update({
  id: '/api/_monitor/sentry',
  path: '/api/sentry',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiMonitorHealthcheckRoute = ApiMonitorHealthcheckRouteImport.update({
  id: '/api/_monitor/healthcheck',
  path: '/api/healthcheck',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSettingsUsersRoute = SettingsSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSettingsRolesRoute = SettingsSettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSettingsQueryBuilderRoute =
  SettingsSettingsQueryBuilderRouteImport.update({
    id: '/settings/query-builder',
    path: '/settings/query-builder',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsSettingsGeneralRoute = SettingsSettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSettingsDesignRoute = SettingsSettingsDesignRouteImport.update({
  id: '/settings/design',
  path: '/settings/design',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const MonitorSentrySsrPageRoute = MonitorSentrySsrPageRouteImport.update({
  id: '/_monitor/sentry/ssr-page',
  path: '/sentry/ssr-page',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitorSentryCsrPageRoute = MonitorSentryCsrPageRouteImport.update({
  id: '/_monitor/sentry/csr-page',
  path: '/sentry/csr-page',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitorPreviewErrorPageRoute = MonitorPreviewErrorPageRouteImport.update({
  id: '/_monitor/preview/error-page',
  path: '/preview/error-page',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseTableTableIdRouteRoute = BaseTableTableIdRouteRouteImport.update({
  id: '/table/$tableId',
  path: '/table/$tableId',
  getParentRoute: () => BaseRouteRoute,
} as any)
const SettingsDeveloperToolQueryBuilderRoute =
  SettingsDeveloperToolQueryBuilderRouteImport.update({
    id: '/developer/tool/query-builder',
    path: '/developer/tool/query-builder',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const BaseTableTableIdViewIdRoute = BaseTableTableIdViewIdRouteImport.update({
  id: '/$viewId',
  path: '/$viewId',
  getParentRoute: () => BaseTableTableIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/auth/forget-password': typeof AuthForgetPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/': typeof BaseIndexRoute
  '/table/$tableId': typeof BaseTableTableIdRouteRouteWithChildren
  '/preview/error-page': typeof MonitorPreviewErrorPageRoute
  '/sentry/csr-page': typeof MonitorSentryCsrPageRoute
  '/sentry/ssr-page': typeof MonitorSentrySsrPageRoute
  '/settings/design': typeof SettingsSettingsDesignRoute
  '/settings/general': typeof SettingsSettingsGeneralRoute
  '/settings/query-builder': typeof SettingsSettingsQueryBuilderRoute
  '/settings/roles': typeof SettingsSettingsRolesRoute
  '/settings/users': typeof SettingsSettingsUsersRoute
  '/api/healthcheck': typeof ApiMonitorHealthcheckRoute
  '/api/sentry': typeof ApiMonitorSentryRoute
  '/table/$tableId/$viewId': typeof BaseTableTableIdViewIdRoute
  '/developer/tool/query-builder': typeof SettingsDeveloperToolQueryBuilderRoute
}
export interface FileRoutesByTo {
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/auth/forget-password': typeof AuthForgetPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/': typeof BaseIndexRoute
  '/table/$tableId': typeof BaseTableTableIdRouteRouteWithChildren
  '/preview/error-page': typeof MonitorPreviewErrorPageRoute
  '/sentry/csr-page': typeof MonitorSentryCsrPageRoute
  '/sentry/ssr-page': typeof MonitorSentrySsrPageRoute
  '/settings/design': typeof SettingsSettingsDesignRoute
  '/settings/general': typeof SettingsSettingsGeneralRoute
  '/settings/query-builder': typeof SettingsSettingsQueryBuilderRoute
  '/settings/roles': typeof SettingsSettingsRolesRoute
  '/settings/users': typeof SettingsSettingsUsersRoute
  '/api/healthcheck': typeof ApiMonitorHealthcheckRoute
  '/api/sentry': typeof ApiMonitorSentryRoute
  '/table/$tableId/$viewId': typeof BaseTableTableIdViewIdRoute
  '/developer/tool/query-builder': typeof SettingsDeveloperToolQueryBuilderRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_base': typeof BaseRouteRouteWithChildren
  '/_settings': typeof SettingsRouteRouteWithChildren
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/auth/forget-password': typeof AuthForgetPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/_base/': typeof BaseIndexRoute
  '/_base/table/$tableId': typeof BaseTableTableIdRouteRouteWithChildren
  '/_monitor/preview/error-page': typeof MonitorPreviewErrorPageRoute
  '/_monitor/sentry/csr-page': typeof MonitorSentryCsrPageRoute
  '/_monitor/sentry/ssr-page': typeof MonitorSentrySsrPageRoute
  '/_settings/settings/design': typeof SettingsSettingsDesignRoute
  '/_settings/settings/general': typeof SettingsSettingsGeneralRoute
  '/_settings/settings/query-builder': typeof SettingsSettingsQueryBuilderRoute
  '/_settings/settings/roles': typeof SettingsSettingsRolesRoute
  '/_settings/settings/users': typeof SettingsSettingsUsersRoute
  '/api/_monitor/healthcheck': typeof ApiMonitorHealthcheckRoute
  '/api/_monitor/sentry': typeof ApiMonitorSentryRoute
  '/_base/table/$tableId/$viewId': typeof BaseTableTableIdViewIdRoute
  '/_settings/developer/tool/query-builder': typeof SettingsDeveloperToolQueryBuilderRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/403'
    | '/404'
    | '/auth/forget-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/'
    | '/table/$tableId'
    | '/preview/error-page'
    | '/sentry/csr-page'
    | '/sentry/ssr-page'
    | '/settings/design'
    | '/settings/general'
    | '/settings/query-builder'
    | '/settings/roles'
    | '/settings/users'
    | '/api/healthcheck'
    | '/api/sentry'
    | '/table/$tableId/$viewId'
    | '/developer/tool/query-builder'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/403'
    | '/404'
    | '/auth/forget-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/'
    | '/table/$tableId'
    | '/preview/error-page'
    | '/sentry/csr-page'
    | '/sentry/ssr-page'
    | '/settings/design'
    | '/settings/general'
    | '/settings/query-builder'
    | '/settings/roles'
    | '/settings/users'
    | '/api/healthcheck'
    | '/api/sentry'
    | '/table/$tableId/$viewId'
    | '/developer/tool/query-builder'
  id:
    | '__root__'
    | '/_base'
    | '/_settings'
    | '/403'
    | '/404'
    | '/auth/forget-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/_base/'
    | '/_base/table/$tableId'
    | '/_monitor/preview/error-page'
    | '/_monitor/sentry/csr-page'
    | '/_monitor/sentry/ssr-page'
    | '/_settings/settings/design'
    | '/_settings/settings/general'
    | '/_settings/settings/query-builder'
    | '/_settings/settings/roles'
    | '/_settings/settings/users'
    | '/api/_monitor/healthcheck'
    | '/api/_monitor/sentry'
    | '/_base/table/$tableId/$viewId'
    | '/_settings/developer/tool/query-builder'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BaseRouteRoute: typeof BaseRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  AuthForgetPasswordRoute: typeof AuthForgetPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  MonitorPreviewErrorPageRoute: typeof MonitorPreviewErrorPageRoute
  MonitorSentryCsrPageRoute: typeof MonitorSentryCsrPageRoute
  MonitorSentrySsrPageRoute: typeof MonitorSentrySsrPageRoute
  ApiMonitorHealthcheckRoute: typeof ApiMonitorHealthcheckRoute
  ApiMonitorSentryRoute: typeof ApiMonitorSentryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_settings': {
      id: '/_settings'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_base': {
      id: '/_base'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BaseRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_base/': {
      id: '/_base/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof BaseIndexRouteImport
      parentRoute: typeof BaseRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forget-password': {
      id: '/auth/forget-password'
      path: '/auth/forget-password'
      fullPath: '/auth/forget-password'
      preLoaderRoute: typeof AuthForgetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/_monitor/sentry': {
      id: '/api/_monitor/sentry'
      path: '/api/sentry'
      fullPath: '/api/sentry'
      preLoaderRoute: typeof ApiMonitorSentryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/_monitor/healthcheck': {
      id: '/api/_monitor/healthcheck'
      path: '/api/healthcheck'
      fullPath: '/api/healthcheck'
      preLoaderRoute: typeof ApiMonitorHealthcheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_settings/settings/users': {
      id: '/_settings/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsSettingsUsersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_settings/settings/roles': {
      id: '/_settings/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsSettingsRolesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_settings/settings/query-builder': {
      id: '/_settings/settings/query-builder'
      path: '/settings/query-builder'
      fullPath: '/settings/query-builder'
      preLoaderRoute: typeof SettingsSettingsQueryBuilderRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_settings/settings/general': {
      id: '/_settings/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsSettingsGeneralRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_settings/settings/design': {
      id: '/_settings/settings/design'
      path: '/settings/design'
      fullPath: '/settings/design'
      preLoaderRoute: typeof SettingsSettingsDesignRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_monitor/sentry/ssr-page': {
      id: '/_monitor/sentry/ssr-page'
      path: '/sentry/ssr-page'
      fullPath: '/sentry/ssr-page'
      preLoaderRoute: typeof MonitorSentrySsrPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_monitor/sentry/csr-page': {
      id: '/_monitor/sentry/csr-page'
      path: '/sentry/csr-page'
      fullPath: '/sentry/csr-page'
      preLoaderRoute: typeof MonitorSentryCsrPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_monitor/preview/error-page': {
      id: '/_monitor/preview/error-page'
      path: '/preview/error-page'
      fullPath: '/preview/error-page'
      preLoaderRoute: typeof MonitorPreviewErrorPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_base/table/$tableId': {
      id: '/_base/table/$tableId'
      path: '/table/$tableId'
      fullPath: '/table/$tableId'
      preLoaderRoute: typeof BaseTableTableIdRouteRouteImport
      parentRoute: typeof BaseRouteRoute
    }
    '/_settings/developer/tool/query-builder': {
      id: '/_settings/developer/tool/query-builder'
      path: '/developer/tool/query-builder'
      fullPath: '/developer/tool/query-builder'
      preLoaderRoute: typeof SettingsDeveloperToolQueryBuilderRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/_base/table/$tableId/$viewId': {
      id: '/_base/table/$tableId/$viewId'
      path: '/$viewId'
      fullPath: '/table/$tableId/$viewId'
      preLoaderRoute: typeof BaseTableTableIdViewIdRouteImport
      parentRoute: typeof BaseTableTableIdRouteRoute
    }
  }
}

interface BaseTableTableIdRouteRouteChildren {
  BaseTableTableIdViewIdRoute: typeof BaseTableTableIdViewIdRoute
}

const BaseTableTableIdRouteRouteChildren: BaseTableTableIdRouteRouteChildren = {
  BaseTableTableIdViewIdRoute: BaseTableTableIdViewIdRoute,
}

const BaseTableTableIdRouteRouteWithChildren =
  BaseTableTableIdRouteRoute._addFileChildren(
    BaseTableTableIdRouteRouteChildren,
  )

interface BaseRouteRouteChildren {
  BaseIndexRoute: typeof BaseIndexRoute
  BaseTableTableIdRouteRoute: typeof BaseTableTableIdRouteRouteWithChildren
}

const BaseRouteRouteChildren: BaseRouteRouteChildren = {
  BaseIndexRoute: BaseIndexRoute,
  BaseTableTableIdRouteRoute: BaseTableTableIdRouteRouteWithChildren,
}

const BaseRouteRouteWithChildren = BaseRouteRoute._addFileChildren(
  BaseRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsSettingsDesignRoute: typeof SettingsSettingsDesignRoute
  SettingsSettingsGeneralRoute: typeof SettingsSettingsGeneralRoute
  SettingsSettingsQueryBuilderRoute: typeof SettingsSettingsQueryBuilderRoute
  SettingsSettingsRolesRoute: typeof SettingsSettingsRolesRoute
  SettingsSettingsUsersRoute: typeof SettingsSettingsUsersRoute
  SettingsDeveloperToolQueryBuilderRoute: typeof SettingsDeveloperToolQueryBuilderRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsSettingsDesignRoute: SettingsSettingsDesignRoute,
  SettingsSettingsGeneralRoute: SettingsSettingsGeneralRoute,
  SettingsSettingsQueryBuilderRoute: SettingsSettingsQueryBuilderRoute,
  SettingsSettingsRolesRoute: SettingsSettingsRolesRoute,
  SettingsSettingsUsersRoute: SettingsSettingsUsersRoute,
  SettingsDeveloperToolQueryBuilderRoute:
    SettingsDeveloperToolQueryBuilderRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  BaseRouteRoute: BaseRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  R403Route: R403Route,
  R404Route: R404Route,
  AuthForgetPasswordRoute: AuthForgetPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  MonitorPreviewErrorPageRoute: MonitorPreviewErrorPageRoute,
  MonitorSentryCsrPageRoute: MonitorSentryCsrPageRoute,
  MonitorSentrySsrPageRoute: MonitorSentrySsrPageRoute,
  ApiMonitorHealthcheckRoute: ApiMonitorHealthcheckRoute,
  ApiMonitorSentryRoute: ApiMonitorSentryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
